import {
  React,
  Component,
  withRouter,
  withCookies,
  routes,
  axios
} from 'imports/CommonImports';

import {
  Drawer,
  AppBar,
  IconButton,
  TextField,
  Chip,
  CircularProgress,
  Divider
} from 'material-ui';

import {
  NavigationCloseIcon,
  CommentIcon,
  SendIcon
} from 'imports/IconsImports';

const styles = {
  container: {
    textTransform: 'none'
  },
  header: {
    backgroundColor: 'rgb(33, 47, 85)',
  },
  commentsContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '20px'
  },
  messagersContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    fontSize: '12px',
    padding: '0 0.5em 1em 0.5em',
  },
  messages: {
    margin: '10px',
    overflowY: 'scroll',
    maxHeight: '70%',
    height: '70%',
  },
  text: {
    padding: '0.7em',
    display: 'flex',
    alignItems: 'center',
    borderTop: '1px solid #F0F0EF'
  },
  textArea: {
    width: '320px'
  },
  chip:{
    display: 'flex',
    margin: '5px',
    backgroundColor: '#F0F0EF',
  },
  message: {
    overflow:'hidden',
    lineHeight: '110%',
    marginTop: '0px',
    marginBottom: '5px',
    whiteSpace: 'pre-line',
    maxWidth: '15em'
  },
  timestamp:{
    marginBottom: '0px',
    fontStyle: 'italic',
    fontSize: 'smaller'
  }
}

const getChipColor = {
  'Líder de proyecto': '#1b2543',
  'Gerente de área': '#5c5f66',
  'Gerente Innovación': '#11AB99',
  'Control de gestión': '#FF952B',
  'Innspiral': '#ba0f0f',
}

const translateType = {
  'selection': 'Selección',
  'information': 'Información',
  'calculation': 'Cálculo',
  'method': 'Method',
}

class Chat extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      loading: true,
      error: false,
      comments: [],
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
      text: "",
      type: this.props.type,
      sending: false,
      messagers: props.type === 'selection' ? ['INNSPIRAL', 'Gerente de Innovación'] : ['INNSPIRAL', 'Gerente de Innovación', 'Control de gestión', 'Sponsor de proyecto', 'Líder de proyecto']
    };
  }

  handleToggle = () => {
    this.setState({open: !this.state.open});
  }

  handleClose = () => this.setState({open: false});

  componentDidMount(){
    this.getComments();
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.commentsContainer}>
          <IconButton
            tooltip="Comentarios"
            iconStyle={{color: '#212F55'}}
            style={{padding: '0px'}}
            onClick={this.handleToggle}
            >
            <CommentIcon />
          </IconButton>
        </div>
        <Drawer
          docked={false}
          width={400}
          openSecondary={true}
          open={this.state.open}
          onRequestChange={(open) => this.setState({open})}
          style={styles.chatWindow}
        >
          <AppBar
            style={{...styles.header}}
            title={translateType[this.props.type] + ' - ' + this.props.project.information.name}
            iconElementLeft={<div></div>}
            iconElementRight={<IconButton onClick={this.handleClose}><NavigationCloseIcon /></IconButton>}
          />
        <p style={{marginBottom: '0.5em', textAlign: 'center'}}>En esta conversación</p>
          <div style={styles.messagersContainer}>
            {this.state.messagers.map((messager, i) => {
              if(this.state.messagers.length - 1 === i)
                return(<div>{messager}</div>)
              else
                return(<div>{messager + '-'}</div>)
            })
            }
          </div>
          <Divider/>
          <div id="messages" style={styles.messages}>
            {this.state.error ?
              <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
                <p>Error al cargar los mensajes. Por favor recarga la página o intenta más tarde.</p>
              </div>:<div></div>
            }
            {this.state.loading ?
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
                <CircularProgress color='#9e9e9e' size={80} thickness={5} />
              </div>:<div></div>
            }
            {this.state.comments.map((comment, i) =>{
              return(
                <div key={i} style={comment.user__profile__position === this.state.user.position ? {justifyContent: 'flex-end', display: 'flex'} : null}>
                  <Chip key={i} style={styles.chip}>
                    <div style={{color: getChipColor[comment.user__profile__position]}}>
                      <b>{comment.user__first_name + " " + comment.user__last_name}</b> - {comment.user__profile__position}
                    </div>
                    <p style={styles.message}>{comment.text}</p>
                    <p style={styles.timestamp}>{(new Date(comment.date)).toLocaleString()}</p>
                  </Chip>
                </div>
            )
            })}
            {this.state.comments.length === 0 && !this.state.loading ? <i>No hay comentarios</i> : <div></div>}
          </div>
          <div style={styles.text}>
            <TextField
              hintText="Escribe tus comentarios."
              style={{...styles.textArea}}
              multiLine={true}
              rowsMax={5}
              onChange={(event, newValue)=>{this.setState({text:newValue})}}
              value={this.state.text}
            />
          {this.state.sending ?
            <CircularProgress color='#9e9e9e' size={20} thickness={3} />
            :
            <IconButton onClick={this.postComment}>
              <SendIcon />
            </IconButton>
          }

          </div>
        </Drawer>
      </div>
    );
  }

  setScrollToBottom = () => {
    // Set scroll to bottom of div
    var messagesDiv = document.getElementById("messages");
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
  }

  getComments = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.projectComments(this.props.project.id))
      .then((response) => {
        this.setState({
          error: false,
          loading: false,
          comments: response.data.comments.filter(comment => comment.type === this.state.type)
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          error: true,
          loading: false
        });
      });
  }

  postComment = () => {
    this.setState({sending: true})
    var comment = {text: this.state.text, user_id: this.state.user.id, type: this.state.type}
    axios({
      method: 'post',
      headers: {'Authorization': "Token "+ this.state.token},
      url: routes.host + routes.projectComments(this.props.project.id),
      data: comment
    })
    .then((response) => {
      var comments = this.state.comments;
      comments.push(response.data.comment);
      this.setState({
        comments: comments,
        text: "",
        sending: false
      }, () => {this.setScrollToBottom()});
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        error: true
      });
    });
  }
}

export default withCookies(withRouter(Chat));



// WEBPACK FOOTER //
// ./src/components/files/Chat.js